export * from './auth';
export * from './auth.module';
//# sourceMappingURL=public_api.js.map


//////////////////
// WEBPACK FOOTER
// C:/thinkbit/conference/hosting/~/angularfire2/auth/public_api.js
// module id = ../../../../angularfire2/auth/public_api.js
// module chunks = 22